/**
 * Generated from the installed Pi model catalog by
 * `bun run generate:pi-model-catalog`. Do not edit manually.
 */
export const PI_MODEL_IDS_BY_PROVIDER = {
  anthropic: [
    'claude-fable-5',
    'claude-haiku-4-5',
    'claude-haiku-4-5-20251001',
    'claude-opus-4-1',
    'claude-opus-4-1-20250805',
    'claude-opus-4-5',
    'claude-opus-4-5-20251101',
    'claude-opus-4-6',
    'claude-opus-4-7',
    'claude-opus-4-8',
    'claude-sonnet-4-5',
    'claude-sonnet-4-5-20250929',
    'claude-sonnet-4-6',
    'claude-sonnet-5',
  ],
  openai: [
    'gpt-4',
    'gpt-4-turbo',
    'gpt-4.1',
    'gpt-4.1-mini',
    'gpt-4.1-nano',
    'gpt-4o',
    'gpt-4o-2024-05-13',
    'gpt-4o-2024-08-06',
    'gpt-4o-2024-11-20',
    'gpt-4o-mini',
    'gpt-5',
    'gpt-5-chat-latest',
    'gpt-5-codex',
    'gpt-5-mini',
    'gpt-5-nano',
    'gpt-5-pro',
    'gpt-5.1',
    'gpt-5.1-chat-latest',
    'gpt-5.1-codex',
    'gpt-5.1-codex-max',
    'gpt-5.1-codex-mini',
    'gpt-5.2',
    'gpt-5.2-chat-latest',
    'gpt-5.2-codex',
    'gpt-5.2-pro',
    'gpt-5.3-chat-latest',
    'gpt-5.3-codex',
    'gpt-5.3-codex-spark',
    'gpt-5.4',
    'gpt-5.4-mini',
    'gpt-5.4-nano',
    'gpt-5.4-pro',
    'gpt-5.5',
    'gpt-5.5-pro',
    'gpt-5.6-luna',
    'gpt-5.6-sol',
    'gpt-5.6-terra',
    'gpt-realtime-2.1',
    'o1',
    'o1-pro',
    'o3',
    'o3-deep-research',
    'o3-mini',
    'o3-pro',
    'o4-mini',
    'o4-mini-deep-research',
  ],
  google: [
    'gemini-2.0-flash',
    'gemini-2.0-flash-lite',
    'gemini-2.5-flash',
    'gemini-2.5-flash-lite',
    'gemini-2.5-pro',
    'gemini-3-flash-preview',
    'gemini-3-pro-preview',
    'gemini-3.1-flash-lite',
    'gemini-3.1-flash-lite-preview',
    'gemini-3.1-pro-preview',
    'gemini-3.1-pro-preview-customtools',
    'gemini-3.5-flash',
    'gemini-flash-latest',
    'gemini-flash-lite-latest',
    'gemma-4-26b-a4b-it',
    'gemma-4-31b-it',
  ],
  xai: ['grok-4.3', 'grok-4.5', 'grok-build-0.1'],
  deepseek: ['deepseek-v4-flash', 'deepseek-v4-pro'],
  mistral: [
    'codestral-latest',
    'devstral-2512',
    'devstral-latest',
    'devstral-medium-2507',
    'devstral-medium-latest',
    'devstral-small-2505',
    'devstral-small-2507',
    'labs-devstral-small-2512',
    'magistral-medium-latest',
    'magistral-small',
    'ministral-3b-latest',
    'ministral-8b-latest',
    'mistral-large-2411',
    'mistral-large-2512',
    'mistral-large-latest',
    'mistral-medium-2505',
    'mistral-medium-2508',
    'mistral-medium-2604',
    'mistral-medium-3.5',
    'mistral-medium-latest',
    'mistral-nemo',
    'mistral-small-2506',
    'mistral-small-2603',
    'mistral-small-latest',
    'open-mistral-7b',
    'open-mistral-nemo',
    'open-mixtral-8x22b',
    'open-mixtral-8x7b',
    'pixtral-12b',
    'pixtral-large-latest',
  ],
  groq: [
    'llama-3.1-8b-instant',
    'llama-3.3-70b-versatile',
    'meta-llama/llama-4-scout-17b-16e-instruct',
    'openai/gpt-oss-120b',
    'openai/gpt-oss-20b',
    'openai/gpt-oss-safeguard-20b',
    'qwen/qwen3-32b',
  ],
  cerebras: ['gemma-4-31b', 'gpt-oss-120b', 'zai-glm-4.7'],
  openrouter: [
    'ai21/jamba-large-1.7',
    'aion-labs/aion-2.0',
    'aion-labs/aion-3.0',
    'aion-labs/aion-3.0-mini',
    'amazon/nova-2-lite-v1',
    'amazon/nova-lite-v1',
    'amazon/nova-micro-v1',
    'amazon/nova-premier-v1',
    'amazon/nova-pro-v1',
    'anthropic/claude-3-haiku',
    'anthropic/claude-fable-5',
    'anthropic/claude-haiku-4.5',
    'anthropic/claude-opus-4',
    'anthropic/claude-opus-4.1',
    'anthropic/claude-opus-4.5',
    'anthropic/claude-opus-4.6',
    'anthropic/claude-opus-4.7',
    'anthropic/claude-opus-4.7-fast',
    'anthropic/claude-opus-4.8',
    'anthropic/claude-opus-4.8-fast',
    'anthropic/claude-sonnet-4',
    'anthropic/claude-sonnet-4.5',
    'anthropic/claude-sonnet-4.6',
    'anthropic/claude-sonnet-5',
    'arcee-ai/trinity-large-thinking',
    'arcee-ai/virtuoso-large',
    'auto',
    'bytedance-seed/seed-1.6',
    'bytedance-seed/seed-1.6-flash',
    'bytedance-seed/seed-2.0-lite',
    'bytedance-seed/seed-2.0-mini',
    'cohere/command-r-08-2024',
    'cohere/command-r-plus-08-2024',
    'cohere/north-mini-code:free',
    'deepseek/deepseek-chat',
    'deepseek/deepseek-chat-v3-0324',
    'deepseek/deepseek-chat-v3.1',
    'deepseek/deepseek-r1',
    'deepseek/deepseek-r1-0528',
    'deepseek/deepseek-v3.1-terminus',
    'deepseek/deepseek-v3.2',
    'deepseek/deepseek-v3.2-exp',
    'deepseek/deepseek-v4-flash',
    'deepseek/deepseek-v4-pro',
    'google/gemini-2.5-flash',
    'google/gemini-2.5-flash-lite',
    'google/gemini-2.5-pro',
    'google/gemini-2.5-pro-preview',
    'google/gemini-2.5-pro-preview-05-06',
    'google/gemini-3-flash-preview',
    'google/gemini-3-pro-image',
    'google/gemini-3.1-flash-lite',
    'google/gemini-3.1-flash-lite-preview',
    'google/gemini-3.1-pro-preview',
    'google/gemini-3.1-pro-preview-customtools',
    'google/gemini-3.5-flash',
    'google/gemma-3-12b-it',
    'google/gemma-3-27b-it',
    'google/gemma-4-26b-a4b-it',
    'google/gemma-4-26b-a4b-it:free',
    'google/gemma-4-31b-it',
    'google/gemma-4-31b-it:free',
    'ibm-granite/granite-4.1-8b',
    'inception/mercury-2',
    'inclusionai/ling-2.6-1t',
    'inclusionai/ling-2.6-flash',
    'inclusionai/ring-2.6-1t',
    'kwaipilot/kat-coder-air-v2.5',
    'kwaipilot/kat-coder-pro-v2',
    'kwaipilot/kat-coder-pro-v2.5',
    'meta-llama/llama-3.1-70b-instruct',
    'meta-llama/llama-3.1-8b-instruct',
    'meta-llama/llama-3.3-70b-instruct',
    'meta-llama/llama-3.3-70b-instruct:free',
    'meta-llama/llama-4-maverick',
    'meta-llama/llama-4-scout',
    'meta/muse-spark-1.1',
    'minimax/minimax-m1',
    'minimax/minimax-m2',
    'minimax/minimax-m2.1',
    'minimax/minimax-m2.5',
    'minimax/minimax-m2.7',
    'minimax/minimax-m3',
    'mistralai/codestral-2508',
    'mistralai/devstral-2512',
    'mistralai/ministral-14b-2512',
    'mistralai/ministral-3b-2512',
    'mistralai/ministral-8b-2512',
    'mistralai/mistral-large',
    'mistralai/mistral-large-2407',
    'mistralai/mistral-large-2512',
    'mistralai/mistral-medium-3',
    'mistralai/mistral-medium-3-5',
    'mistralai/mistral-medium-3.1',
    'mistralai/mistral-nemo',
    'mistralai/mistral-saba',
    'mistralai/mistral-small-2603',
    'mistralai/mistral-small-3.2-24b-instruct',
    'mistralai/mixtral-8x22b-instruct',
    'mistralai/voxtral-small-24b-2507',
    'moonshotai/kimi-k2',
    'moonshotai/kimi-k2-0905',
    'moonshotai/kimi-k2-thinking',
    'moonshotai/kimi-k2.5',
    'moonshotai/kimi-k2.6',
    'moonshotai/kimi-k2.7-code',
    'moonshotai/kimi-k3',
    'nex-agi/nex-n2-mini',
    'nex-agi/nex-n2-pro',
    'nvidia/llama-3.3-nemotron-super-49b-v1.5',
    'nvidia/nemotron-3-nano-30b-a3b',
    'nvidia/nemotron-3-nano-30b-a3b:free',
    'nvidia/nemotron-3-nano-omni-30b-a3b-reasoning:free',
    'nvidia/nemotron-3-super-120b-a12b',
    'nvidia/nemotron-3-super-120b-a12b:free',
    'nvidia/nemotron-3-ultra-550b-a55b',
    'nvidia/nemotron-3-ultra-550b-a55b:free',
    'nvidia/nemotron-nano-12b-v2-vl:free',
    'nvidia/nemotron-nano-9b-v2:free',
    'openai/gpt-3.5-turbo',
    'openai/gpt-3.5-turbo-0613',
    'openai/gpt-3.5-turbo-16k',
    'openai/gpt-4',
    'openai/gpt-4-turbo',
    'openai/gpt-4-turbo-preview',
    'openai/gpt-4.1',
    'openai/gpt-4.1-mini',
    'openai/gpt-4.1-nano',
    'openai/gpt-4o',
    'openai/gpt-4o-2024-05-13',
    'openai/gpt-4o-2024-08-06',
    'openai/gpt-4o-2024-11-20',
    'openai/gpt-4o-mini',
    'openai/gpt-4o-mini-2024-07-18',
    'openai/gpt-5',
    'openai/gpt-5-codex',
    'openai/gpt-5-mini',
    'openai/gpt-5-nano',
    'openai/gpt-5-pro',
    'openai/gpt-5.1',
    'openai/gpt-5.1-chat',
    'openai/gpt-5.1-codex',
    'openai/gpt-5.1-codex-max',
    'openai/gpt-5.1-codex-mini',
    'openai/gpt-5.2',
    'openai/gpt-5.2-chat',
    'openai/gpt-5.2-codex',
    'openai/gpt-5.2-pro',
    'openai/gpt-5.3-chat',
    'openai/gpt-5.3-codex',
    'openai/gpt-5.4',
    'openai/gpt-5.4-mini',
    'openai/gpt-5.4-nano',
    'openai/gpt-5.4-pro',
    'openai/gpt-5.5',
    'openai/gpt-5.5-pro',
    'openai/gpt-5.6-luna',
    'openai/gpt-5.6-luna-pro',
    'openai/gpt-5.6-sol',
    'openai/gpt-5.6-sol-pro',
    'openai/gpt-5.6-terra',
    'openai/gpt-5.6-terra-pro',
    'openai/gpt-audio',
    'openai/gpt-audio-mini',
    'openai/gpt-chat-latest',
    'openai/gpt-oss-120b',
    'openai/gpt-oss-20b',
    'openai/gpt-oss-20b:free',
    'openai/gpt-oss-safeguard-20b',
    'openai/o1',
    'openai/o3',
    'openai/o3-deep-research',
    'openai/o3-mini',
    'openai/o3-mini-high',
    'openai/o3-pro',
    'openai/o4-mini',
    'openai/o4-mini-deep-research',
    'openai/o4-mini-high',
    'openrouter/auto',
    'openrouter/free',
    'openrouter/fusion',
    'poolside/laguna-m.1',
    'poolside/laguna-m.1:free',
    'poolside/laguna-xs-2.1',
    'poolside/laguna-xs-2.1:free',
    'qwen/qwen-2.5-72b-instruct',
    'qwen/qwen-2.5-7b-instruct',
    'qwen/qwen-plus',
    'qwen/qwen-plus-2025-07-28',
    'qwen/qwen-plus-2025-07-28:thinking',
    'qwen/qwen3-14b',
    'qwen/qwen3-235b-a22b',
    'qwen/qwen3-235b-a22b-2507',
    'qwen/qwen3-235b-a22b-thinking-2507',
    'qwen/qwen3-30b-a3b',
    'qwen/qwen3-30b-a3b-instruct-2507',
    'qwen/qwen3-30b-a3b-thinking-2507',
    'qwen/qwen3-32b',
    'qwen/qwen3-8b',
    'qwen/qwen3-coder',
    'qwen/qwen3-coder-30b-a3b-instruct',
    'qwen/qwen3-coder-flash',
    'qwen/qwen3-coder-next',
    'qwen/qwen3-coder-plus',
    'qwen/qwen3-coder:free',
    'qwen/qwen3-max',
    'qwen/qwen3-max-thinking',
    'qwen/qwen3-next-80b-a3b-instruct',
    'qwen/qwen3-next-80b-a3b-instruct:free',
    'qwen/qwen3-next-80b-a3b-thinking',
    'qwen/qwen3-vl-235b-a22b-instruct',
    'qwen/qwen3-vl-235b-a22b-thinking',
    'qwen/qwen3-vl-30b-a3b-instruct',
    'qwen/qwen3-vl-30b-a3b-thinking',
    'qwen/qwen3-vl-32b-instruct',
    'qwen/qwen3-vl-8b-instruct',
    'qwen/qwen3-vl-8b-thinking',
    'qwen/qwen3.5-122b-a10b',
    'qwen/qwen3.5-27b',
    'qwen/qwen3.5-35b-a3b',
    'qwen/qwen3.5-397b-a17b',
    'qwen/qwen3.5-9b',
    'qwen/qwen3.5-flash-02-23',
    'qwen/qwen3.5-plus-02-15',
    'qwen/qwen3.5-plus-20260420',
    'qwen/qwen3.6-27b',
    'qwen/qwen3.6-35b-a3b',
    'qwen/qwen3.6-flash',
    'qwen/qwen3.6-max-preview',
    'qwen/qwen3.6-plus',
    'qwen/qwen3.7-max',
    'qwen/qwen3.7-plus',
    'rekaai/reka-edge',
    'relace/relace-search',
    'sakana/fugu-ultra',
    'sao10k/l3.1-euryale-70b',
    'stepfun/step-3.5-flash',
    'stepfun/step-3.7-flash',
    'tencent/hy3',
    'tencent/hy3-preview',
    'tencent/hy3:free',
    'thedrummer/unslopnemo-12b',
    'upstage/solar-pro-3',
    'x-ai/grok-4.20',
    'x-ai/grok-4.3',
    'x-ai/grok-4.5',
    'x-ai/grok-build-0.1',
    'xiaomi/mimo-v2.5',
    'xiaomi/mimo-v2.5-pro',
    'z-ai/glm-4.5',
    'z-ai/glm-4.5-air',
    'z-ai/glm-4.5v',
    'z-ai/glm-4.6',
    'z-ai/glm-4.6v',
    'z-ai/glm-4.7',
    'z-ai/glm-4.7-flash',
    'z-ai/glm-5',
    'z-ai/glm-5-turbo',
    'z-ai/glm-5.1',
    'z-ai/glm-5.2',
    'z-ai/glm-5v-turbo',
    '~anthropic/claude-fable-latest',
    '~anthropic/claude-haiku-latest',
    '~anthropic/claude-opus-latest',
    '~anthropic/claude-sonnet-latest',
    '~google/gemini-flash-latest',
    '~google/gemini-pro-latest',
    '~moonshotai/kimi-latest',
    '~openai/gpt-latest',
    '~openai/gpt-mini-latest',
    '~x-ai/grok-latest',
  ],
  fireworks: [
    'accounts/fireworks/models/deepseek-v4-flash',
    'accounts/fireworks/models/deepseek-v4-pro',
    'accounts/fireworks/models/glm-5p1',
    'accounts/fireworks/models/glm-5p2',
    'accounts/fireworks/models/gpt-oss-120b',
    'accounts/fireworks/models/gpt-oss-20b',
    'accounts/fireworks/models/kimi-k2p6',
    'accounts/fireworks/models/kimi-k2p7-code',
    'accounts/fireworks/models/minimax-m2p7',
    'accounts/fireworks/models/minimax-m3',
    'accounts/fireworks/models/qwen3p7-plus',
    'accounts/fireworks/routers/glm-5p1-fast',
    'accounts/fireworks/routers/glm-5p2-fast',
    'accounts/fireworks/routers/kimi-k2p6-fast',
    'accounts/fireworks/routers/kimi-k2p6-turbo',
    'accounts/fireworks/routers/kimi-k2p7-code-fast',
  ],
  together: [
    'MiniMaxAI/MiniMax-M2.7',
    'MiniMaxAI/MiniMax-M3',
    'Qwen/Qwen2.5-7B-Instruct-Turbo',
    'Qwen/Qwen3-235B-A22B-Instruct-2507-tput',
    'Qwen/Qwen3.5-397B-A17B',
    'Qwen/Qwen3.5-9B',
    'Qwen/Qwen3.6-Plus',
    'Qwen/Qwen3.7-Max',
    'deepseek-ai/DeepSeek-V4-Pro',
    'essentialai/Rnj-1-Instruct',
    'google/gemma-4-31B-it',
    'meta-llama/Llama-3.3-70B-Instruct-Turbo',
    'moonshotai/Kimi-K2.6',
    'moonshotai/Kimi-K2.7-Code',
    'nvidia/nemotron-3-ultra-550b-a55b',
    'openai/gpt-oss-120b',
    'openai/gpt-oss-20b',
    'zai-org/GLM-5',
    'zai-org/GLM-5.1',
    'zai-org/GLM-5.2',
  ],
  nvidia: [
    'meta/llama-3.1-70b-instruct',
    'meta/llama-3.1-8b-instruct',
    'meta/llama-3.2-11b-vision-instruct',
    'meta/llama-3.2-90b-vision-instruct',
    'meta/llama-3.3-70b-instruct',
    'minimaxai/minimax-m3',
    'mistralai/mistral-large-3-675b-instruct-2512',
    'mistralai/mistral-small-4-119b-2603',
    'moonshotai/kimi-k2.6',
    'nvidia/nemotron-3-nano-30b-a3b',
    'nvidia/nemotron-3-nano-omni-30b-a3b-reasoning',
    'nvidia/nemotron-3-super-120b-a12b',
    'nvidia/nemotron-3-ultra-550b-a55b',
    'nvidia/nvidia-nemotron-nano-9b-v2',
    'openai/gpt-oss-120b',
    'openai/gpt-oss-20b',
    'qwen/qwen3.5-122b-a10b',
    'stepfun-ai/step-3.5-flash',
    'stepfun-ai/step-3.7-flash',
    'z-ai/glm-5.2',
  ],
  zai: ['glm-4.5-air', 'glm-4.7', 'glm-5-turbo', 'glm-5.1', 'glm-5.2', 'glm-5v-turbo'],
  kimi: [
    'kimi-k2-0711-preview',
    'kimi-k2-0905-preview',
    'kimi-k2-thinking',
    'kimi-k2-thinking-turbo',
    'kimi-k2-turbo-preview',
    'kimi-k2.5',
    'kimi-k2.6',
    'kimi-k2.7-code',
    'kimi-k2.7-code-highspeed',
    'kimi-k3',
  ],
} as const
